require("dotenv").config();
import Vue from "vue";
import App from "./App";
import router from "./router/index";
import VueGoodTablePlugin from "vue-good-table";
import PaperDashboard from "./plugins/paperDashboard";
import VueResource from "vue-resource";
import "./pages/firebaseInit";
import "vue-notifyjs/themes/default.css";
import "vue-good-table/dist/vue-good-table.css";
import firebase from "firebase";
import Spinner from "vue-spinner-component/src/Spinner.vue";
import Trend from "vuetrend";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import VueJsonp from "vue-jsonp";
import VueSignaturePad from "vue-signature-pad";
import * as VueGoogleMaps from "vue2-google-maps";
import VueOnlineProp from "vue-online-prop";
import vueAwesomeCountdown from 'vue-awesome-countdown';
import moment from 'moment';
import 'moment/locale/de';


const ignoreWarnMessage = 'The .native modifier for v-on is only valid on components but it was used on <div>.';
Vue.config.warnHandler = function (msg, vm, trace) {
  // `trace` is the component hierarchy trace
  if (msg === ignoreWarnMessage) {
    msg = null;
    vm = null;
    trace = null;
  }
}

Vue.filter('formatDate', function(value) {
  if (value) {
    moment.locale('de');
    return moment(String(value)).format('L');
  }
});

Vue.filter('formatDateShort', function(value) {
  if (value) {
    moment.locale('de');
    return moment(String(value)).format('L').slice(0,6);
  }
});

Vue.filter('formatTime', function(value) {
  if (value) {
    moment.locale('de');
    return moment(String(value)).format('LT');
  }
});

Vue.use(VueOnlineProp);
Vue.use(vueAwesomeCountdown, 'vac');
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
    libraries: "places"
  }
});
Vue.use(VueJsonp);
Vue.use(Trend);
Vue.use(VueResource);
Vue.use(PaperDashboard);
Vue.use(VueGoodTablePlugin);
Vue.use(Spinner);
Vue.use(Vuetify);
Vue.use(VueSignaturePad);
let app;
// eslint-disable-next-line no-unused-vars
firebase.auth().onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({
      router,
      render: h => h(App)
    }).$mount("#app");
  }
});

/* eslint-disable no-new */
